<template>
    <div>

        <vue-headful title="Employee Disciplinary Actions :: MeritEHS"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/employees/disciplinary-actions`">
                        <i class="fa fa-gavel"></i> Disciplinary Actions
                    </router-link>
                </li>
                <li class="breadcrumb-item active">
                    <template v-if="action.disc_violation_id">{{ action.violation_name }}</template>
                    <template v-else>{{ action.other_violation_name }}</template>
                    on {{ action.disc_action_date | moment("MM/DD/YYYY") }} by {{ action.employee_first_name }} {{ action.employee_last_name }}
                </li>
            </ol>
        </h4>

        <div class="row">
            <div class="col-xl-8 col-lg-12">
                <div class="card">
                    <div class="card-header">
                        Details
                        <div class="float-sm-right float-none">
                            <router-link :to="`/employees/disciplinary-actions/edit/${action.disc_action_id}`" class="btn btn-sm btn-light" v-if="canEdit">
                                <i class="fa fa-edit"></i> Edit
                            </router-link>
                            <b-dropdown right text="Actions" variant="light" size="sm">
                                <b-dropdown-item :to="`/employees/disciplinary-actions/email/${action.disc_action_id}`"><i class="fa fa-envelope"></i> Email Employee for Verification</b-dropdown-item>
                            </b-dropdown>
                            <router-link :to="`/employees/disciplinary-actions/pdf/${action.disc_action_id}`" class="btn btn-sm btn-light">
                                <i class="fa fa-file-pdf-o"></i> PDF
                            </router-link>
                            <router-link :to="`/employees/disciplinary-actions/delete/${action.disc_action_id}`" class="btn btn-sm btn-light" v-if="canEdit">
                                <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-6 col-lg-12 mb-xl-0 mb-lg-2">
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Date:</div>
                                    <div class="col-lg-8">{{ action.disc_action_date | moment("MM/DD/YYYY") }}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Supervisor:</div>
                                    <div class="col-lg-8"><user-name :user="supervisor" /></div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Employee:</div>
                                    <div class="col-lg-8">
                                        <router-link :to="`/employees/view/${action.employee_id}`">{{ action.employee_first_name }} {{ action.employee_last_name }}</router-link>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Jobsite:</div>
                                    <div class="col-lg-8">
                                        <router-link :to="`/jobsites/view/${action.jobsite_id}`">{{ action.JobsiteNumber }} - {{ action.JobsiteName }}</router-link>
                                    </div>
                                </div>
                                <template v-if="action.email_sent_at">
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Email to Employee:</div>
                                        <div class="col-lg-8">
                                            {{ action.email_sent_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-lg-4 text-muted">Employee Acknowledged: <i class="fa fa-question-circle" title="If the Disciplinary Action was emailed to the Employee through MeritEHS, this timestamp reflects when the employee open the email and check off the box acknowledging the disciplinary action."></i></div>
                                        <div class="col-lg-8">
                                            <span v-if="action.email_ack_at">{{ action.email_ack_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                                        </div>
                                    </div>
                                </template>
                                <div class="row mb-2" v-if="incident">
                                    <div class="col-lg-4 text-muted">Incident:</div>
                                    <div class="col-lg-8">
                                        <router-link :to="`/incidents/view/${incident.IncidentId}`">
                                            <incident-name :incident="incident" />
                                        </router-link>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Suspension:</div>
                                    <div class="col-lg-8">
                                        <span v-if="action.days_suspension">{{ action.days_suspension }} Days</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6 col-lg-12">
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Warning Type:</div>
                                    <div class="col-lg-8">{{ action.warning_type }}</div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Discharged:</div>
                                    <div class="col-lg-8">
                                        <label class="badge badge-danger" v-if="action.was_discharged == 1">Yes</label>
                                        <label class="badge badge-success" v-else>No</label>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Violation:</div>
                                    <div class="col-lg-8">
                                        <template v-if="action.disc_violation_id">{{ action.violation_name }}</template>
                                        <template v-else>{{ action.other_violation_name }}</template>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Penalty:</div>
                                    <div class="col-lg-8">
                                        <template v-if="action.disc_violation_id">{{ action.penalty_name }}</template>
                                        <template v-else>{{ action.other_penalty_name }}</template>
                                    </div>
                                </div>
                               <!--<div class="row mb-2" v-if="action.disc_action_key">
                                <div class="col col text-muted">Public URL:</div>
                                <div class="col-md-9">
                                    <a :href="`/employees/disciplinary-actions/key/${action.disc_action_key}`" target="_blank" v-if="action.disc_action_key">
                                        {{ $root.appUrl }}/employees/disciplinary-actions/key/{{ action.disc_action_key }}
                                    </a>
                                </div>
                                </div>-->
                                <div class="row mb-2">
                                    <div class="col-lg-4 text-muted">Bonus Disqualification:</div>
                                    <div class="col-lg-8">
                                        <template v-if="action.disc_violation_id">{{ action.bonus_disqual_time }}</template>
                                        <template v-else>{{ action.other_bonus_disqual_time }}</template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-3">
                    <div class="card-header">
                        Violation Details
                    </div>
                    <div class="card-body" v-html="action.violation_detail"></div>
                </div>
                <div class="card mt-3">
                    <div class="card-header">
                        Employee Reason(s) for action
                    </div>
                    <div class="card-body" v-html="action.reason_detail"></div>
                </div>
                <div class="card mt-3">
                    <div class="card-header">
                        Sign and Date
                    </div>
                    <div class="card-body">
                        <div class="row mb-4">
                            <div class="col-xl-10 col-lg-12">
                                Supervisor: <strong><user-name :user="supervisor" /></strong><br/>
                                Date Signed: <strong>{{ action.supervisor_sig_date | moment("MM/DD/YYYY") }}</strong>
                                <template v-if="action.supervisor_sig_id">
                                    <img v-bind:src="loadSignature(action.supervisor_sig)" class="img-fluid" :ref="`file-${action.supervisor_sig.file_id}`">
                                </template>
                                <template v-else-if="action.supervisor_id == this.$store.state.user.user_id">
                                    <button class="btn btn-sm btn-primary" v-if="!supervisorIsSigning" v-on:click="supervisorIsSigning = true;">
                                        <i class="fa fa-pencil"></i> Sign
                                    </button>
                                </template>
                                <div class="my-4" v-if="supervisorIsSigning">
                                    <VueSignaturePad ref="supervisorSig" class="signature-pad" />
                                    <div class="mt-3">
                                        <button v-on:click="saveSignature('supervisor')" class="btn btn-sm btn-success" :disabled="signing">Sign and Date</button>
                                        <button v-on:click="supervisorIsSigning = false" class="btn btn-sm btn-secondary" :disabled="signing">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr/>

                        <div class="row mb-4">
                            <div class="col-xl-10 col-lg-12">
                                Employee: <strong>{{ action.employee_first_name }} {{ action.employee_last_name }}</strong><br/>
                                Date Signed: <strong>{{ action.employee_sig_date | moment("MM/DD/YYYY") }}</strong>
                                <template v-if="action.employee_sig_id">
                                    <img v-bind:src="loadSignature(action.employee_sig)" class="img-fluid" :ref="`file-${action.employee_sig.file_id}`">
                                </template>
                                <template v-else>
                                    <button class="btn btn-sm btn-primary" v-if="!employeeIsSigning" v-on:click="employeeIsSigning = true;">
                                        <i class="fa fa-pencil"></i> Sign
                                    </button>
                                </template>
                                <div class="my-4" v-if="employeeIsSigning">
                                    <VueSignaturePad ref="employeeSig" class="signature-pad" />
                                    <div class="mt-3">
                                        <button v-on:click="saveSignature('employee')" class="btn btn-sm btn-success" :disabled="signing">Sign and Date</button>
                                        <button v-on:click="employeeIsSigning = false" class="btn btn-sm btn-secondary" :disabled="signing">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <disciplinary-previous ref="empPreviousActions" v-bind:disc_action_id="id" />

                <div class="card mt-3">
                    <div class="card-header"><strong><i class="fa fa-files-o"></i> Files</strong></div>
                    <div class="card-body">
                        <file-list :files="files" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                loading: true,
                supervisorIsSigning: false,
                employeeIsSigning: false,
                signing: false,
                userTimezone: this.$store.state.user.timezone,
                id: this.$route.params.id,
                action: {},
                incident: null,
                files: [],
            }
        },

        computed: {
            canEdit(){
                //Check user
                if(this.action.supervisor_id == this.$store.state.user.user_id)
                {
                    return true;
                }

                //Check manager rights
                if(this.$root.hasPermission('employees.disciplinary.manage'))
                {
                    return true;
                }

                //Send it
                return false;
            },

            supervisor() {
                return {
                    FirstName: this.action.supervisor_first_name,
                    LastName: this.action.supervisor_last_name,
                    deleted_at: this.action.supervisor_deleted_at,
                };
            },
        },

        methods: {
            getAction(){
                //Send it
                this.$http.get('employees/disciplinary-actions/view/'+this.id)
                    .then(res => {
                        //Set
                        this.action = res.data.action;
                        this.incident = res.data.incident;
                        this.files = res.data.files;

                        //Set the emp id
                        this.$refs.empPreviousActions.setEmployeeId(this.action.employee_id);
                    })
                    .then(() => {
                        //Loading
                        this.loading = false;
                    })
            },

            saveSignature(person){
                //This returns a boolean and a data:image stream.
                //Is empty is whether or not the signature is populated.
                const { isEmpty, data } = this.$refs[person+'Sig'].saveSignature();

                //Check for empty
                if(isEmpty)
                {
                    //alert the user
                    alert('Signatures Cannot be Empty');

                    //Stop here
                    return;
                }

                //Signing
                this.signing = true;

                //Send it
                this.$http.post('/employees/disciplinary-actions/sign/'+this.id, {person: person, signature: data})
                    .then(res => {
                        //Alert the User
                        this.$toastr.success('Signature Saved');

                        //Set the file
                        this.action[person+'_sig_id'] = res.data.file_id;
                        this.action[person+'_sig_date'] = res.data.created_at;
                        this.action[person+'_sig'] = res.data;

                        //Reset the Signature pad?
                        this.$refs[person+'Sig'].clearSignature();

                        //Reset
                        this[person+'IsSigning'] = false;
                    })
                    .catch(err => {
                        //Alert
                        console.log(err);
                    })
                    .then(() => {
                        //reset
                        this.signing = false;
                    });
            },

            loadSignature(file){
                //Send it
                this.$http.get('files/view/'+file.file_id, {display_type: 'fluid'})
                    .then(response => {
                        //Sent the ref
                        this.$refs['file-' + file.file_id].src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });

                //Need to return null so it fills the source
                return null;
            },
        },

        mounted(){
            this.getAction();
        }
    }
</script>
<style type="text/css">
    .signature-pad {
        width: 100%;
        height: 300px;
        border: 1px solid #ddd;
    }
</style>